export default "__VITE_ASSET__Cvypd4Mf__"